"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _MyAccountError = _interopRequireDefault(require("../MyAccountError"));
var _PaymentCard = _interopRequireDefault(require("../PaymentCard"));
var _reactRedux = require("react-redux");
var _paymentDetailsSlice = require("../../redux/paymentDetailsSlice");
var _PaymentMethodStyled = require("./PaymentMethodStyled");
var _popupSlice = require("../../redux/popupSlice");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
/* eslint-disable no-nested-ternary */
var AddIcon = function AddIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("circle", {
    stroke: "#5db98f",
    fill: "#5db98f",
    cx: "19",
    cy: "19",
    r: "18"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    strokeWidth: "2",
    stroke: "#f0f3fa",
    d: "M19 8.237v21.526M28.763 19H9.237"
  }));
};
AddIcon.defaultProps = {
  width: "38",
  height: "38",
  xmlns: "http://www.w3.org/2000/svg",
  color: "red"
};
var PaymentMethod = function PaymentMethod() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.paymentDetails;
    }),
    paymentDetails = _useSelector.paymentDetails,
    error = _useSelector.error,
    loading = _useSelector.loading,
    activeOrBoundPaymentDetails = _useSelector.activeOrBoundPaymentDetails;
  var renderPaymentMethodItem = function renderPaymentMethodItem(paymentDetail) {
    var paymentMethod = paymentDetail.paymentMethod,
      id = paymentDetail.id;
    switch (paymentMethod) {
      case 'card':
      case 'paypal':
      case 'apple':
      case 'android':
      case 'amazon':
      case 'roku':
      case 'googlepay':
      case 'applepay':
      case 'ideal':
      case 'bancontact_card':
      case 'bancontact_mobile':
      case 'sofort':
        return /*#__PURE__*/_react.default.createElement(_PaymentCard.default, {
          key: id,
          details: paymentDetail
        });
      default:
        return /*#__PURE__*/_react.default.createElement(_PaymentMethodStyled.Message, null, t('Managed by external service'));
    }
  };
  var activeItems = activeOrBoundPaymentDetails.find(function (item) {
    return item.active;
  });
  (0, _react.useEffect)(function () {
    if ((paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.length) === 0) {
      dispatch((0, _paymentDetailsSlice.fetchPaymentDetails)());
    }
  }, []);
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_PaymentMethodStyled.CardsWrapper, {
      numberOfItems: 1
    }, /*#__PURE__*/_react.default.createElement(_PaymentCard.default, {
      isDataLoaded: false
    }));
  }
  if (error.length !== 0) {
    return /*#__PURE__*/_react.default.createElement(_PaymentMethodStyled.WrapStyled, null, /*#__PURE__*/_react.default.createElement(_MyAccountError.default, {
      generalError: true
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_PaymentMethodStyled.WrapStyled, null, /*#__PURE__*/_react.default.createElement(_PaymentMethodStyled.CardsWrapper, {
    numberOfItems: !activeItems ? activeOrBoundPaymentDetails.length + 1 : activeOrBoundPaymentDetails.length
  }, activeOrBoundPaymentDetails.map(function (paymentDetail) {
    return renderPaymentMethodItem(paymentDetail);
  }), !activeItems && /*#__PURE__*/_react.default.createElement(_MyAccountError.default, {
    icon: AddIcon,
    title: t('Add a payment method!'),
    subtitle: t('Set up a new payment method for your account'),
    withBorder: true,
    onClick: function onClick() {
      return dispatch((0, _popupSlice.updatePaymentDetailsPopup)({
        isOpen: true,
        isLoading: false,
        step: _popupSlice.PAYMENT_DETAILS_STEPS.PAYMENT_DETAILS_UPDATE
      }));
    },
    direction: "row",
    fullWidth: true
  })));
};
var _default = PaymentMethod;
exports.default = _default;